import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSelectedEvent } from '../../actions/events';
import PropTypes from 'prop-types';
import { AdminScroll, TableHeader } from '../../styles/style';
import Event from './Event';
import * as variables from '../../styles/variables';
import styled from 'styled-components';

const ListWrapper = styled.div`
  overflow: scroll;
  border-radius: 8px;
  border: 1px solid #f6f6f6;
  background-color: #fafafa;
`

class AdminEventsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      superhosts: false,
      organization: false,
      incomplete: false,
    }
  }

  render() {
    const { events } = this.props;

    return (
      <React.Fragment>
        {this.props.isLoading && <p>Loading...</p>}

        <TableHeader>
          <div className="name">Name</div>
          <div className="area">Area</div>
          <div className="guests">Guests</div>
        </TableHeader>
        <ListWrapper>
          <AdminScroll>
            {events && events.map((event, index) => {
              return <Event key={event.id} event={event} selected={this.props.selectedEvent && event.id === this.props.selectedEvent.id} onClick={this.props.onSelectedChange} />
            })}
          </AdminScroll>
        </ListWrapper>
      </React.Fragment>
    )
  }
}

AdminEventsList.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
}

export default AdminEventsList
